<template>
  <div class="mx-auto max-w-3xl">
    <div
      v-if="error && !isLoaded"
      class="p-5 bg-red-200 text-red-800"
      v-text="error"
    />
    <div v-else-if="!isLoaded" class="relative min-h-32">
      <saving-overlay opacity="10" text-color="text-gray-700" class="h-64" />
    </div>
    <ProjectParametersForm
      v-else
      :i18n="i18n"
      :input="input"
      :required="requiredFields"
      :optional="optionalFields"
      :store-url="storeUrl"
      @project-created="$emit('project-created', $event)"
    />
  </div>
</template>

<script>
import useSWRV from "@/store/swrv";
import { useStore, computed } from "@/store/composition";

import ProjectParametersForm from "./ProjectParametersForm";

export default {
  props: ["i18n", "applicationSlug", "renderer", "priority", "missingFrames"],
  components: { ProjectParametersForm },

  setup(props) {
    const store = useStore();
    const { data, error, isLoaded } = useSWRV(
      "/api/app/applications/" + props.applicationSlug + "/rules"
    );

    // pre-fill form value
    const input = computed(() => {
      const v = data.value && data.value.form;
      if (!v) {
        return v;
      }
      const form = JSON.parse(JSON.stringify(v));
      form.email = store.state.account.user.email;
      form.renderer_id = props.renderer.id;
      if (props.priority && props.priority.id) {
        form.priority_id = props.priority.id;
      } else {
        form.priority_id = null;
      }
      if (props.missingFrames) {
        form.frames.specific_frames = props.missingFrames;
        form.frames.type = "specific";
      }
      form.receive_finished_email = true; // TODO: customize depending on last setting
      return form;
    });

    // required fields
    const requiredFields = computed(() => {
      const rules = data.value && data.value.rules && data.value.rules.required;
      if (!rules) {
        return [];
      }
      const fields = [];
      Object.keys(rules).forEach((key) => {
        fields.push({
          type: key,
          options: rules[key],
        });
      });
      return fields;
    });

    // optional fields
    const optionalFields = computed(() => {
      const rules = data.value && data.value.rules;
      if (!rules) {
        return [];
      }
      const optionalRules = Object.assign(
        {},
        rules.optional || {},
        rules.customization || {}
      );
      const fields = [];
      Object.keys(optionalRules).forEach((key) => {
        fields.push({
          type: key,
          options: optionalRules[key],
        });
      });
      return fields;
    });

    return {
      error,
      input,
      isLoaded,
      requiredFields,
      optionalFields,
      storeUrl: store.state.dashboard.projects.routes.store,
    };
  },
};
</script>
